import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const token = useSelector((state) => state.auth.token) || localStorage.getItem('token');

  if (!isAuthenticated && !token) {
    return <Navigate to="/login" />;
  }

  return children;
}
